import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { SectionHeader } from './primitives';

// Donut + legend for a 2-3 way split (online vs in-salon, etc.).
// segments: [{ label, value, color, pct, meta }]
export const SegmentSplit = ({ title, segments = [], action }) => {
  const empty = !segments.length || segments.every((s) => !s.value);
  return (
    <div className="cd-card">
      <SectionHeader title={title} action={action} />
      {empty ? (
        <p className="cd-empty">No sales in this period.</p>
      ) : (
        <div className="cd-split">
          <div className="cd-split-chart">
            <ResponsiveContainer width="100%" height={150}>
              <PieChart>
                <Pie data={segments} dataKey="value" innerRadius={46} outerRadius={70} paddingAngle={2} stroke="none">
                  {segments.map((s, i) => <Cell key={i} fill={s.color} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="cd-split-legend">
            {segments.map((s, i) => (
              <div className="cd-split-row" key={i}>
                <span className="cd-split-swatch" style={{ background: s.color }} />
                <span className="cd-split-label">{s.label}</span>
                <span className="cd-split-pct">{s.pct}%</span>
                {s.meta != null && <span className="cd-split-meta">{s.meta}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
